module.exports = __webpack_public_path__ + "static/media/09.c43d4ab8.mp3";